

export const formatDate = (dateString: string): string => {
  const date = new Date(dateString)
  const options: Intl.DateTimeFormatOptions = { 
    year: 'numeric', 
    month: 'short', day: 
    'numeric' 
  }
    return date.toLocaleDateString(undefined, options)
}

export function formatTimeOnly(iso?: string) {
  if (!iso) return '-'
  return new Intl.DateTimeFormat('en-US', { hour: 'numeric', minute: '2-digit', hour12: false }).format(new Date(iso))
}

export function formatTimeString(string?: string) {
  return string?.split('.')[0] || '-'
}